import axios from "axios";
import { useCallback, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { API_URL } from "../../../utils/env";
import { unwrapApiError } from "../../../utils/errors";
import { useGetAccount } from "./useGetAccount";

// POST /account/username is not yet in the OpenAPI spec (and the codegen-api is
// auto-generated, so we don't hand-edit it). Call axios directly with the same
// API-KEY / API-SECRET headers the generated client uses — see apiFetcher.ts.
export const useUpdateUsername = () => {
  const { apiKey, apiSecret } = useContext(AuthContext);
  const { mutate } = useGetAccount();

  return useCallback(
    async (username: string): Promise<string> => {
      if (!apiKey || !apiSecret) {
        throw new Error("Wallet not connected");
      }
      try {
        const res = await axios.post<{ success: boolean; username: string }>(
          `${API_URL}/account/username`,
          { username },
          {
            headers: {
              "API-KEY": apiKey,
              "API-SECRET": apiSecret,
            },
          }
        );
        await mutate();
        return res.data.username;
      } catch (error) {
        throw new Error(unwrapApiError(error));
      }
    },
    [apiKey, apiSecret, mutate]
  );
};
